module.exports = __webpack_public_path__ + "img/logo.2927846f.png";